import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, warehouseValidations } from "./warehouse-schema";
import WarehouseInfo from "./components/WarehouseInfo";
import { useLocation } from "react-router-dom";
import { editWarehouse } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { getWarehouse } from "services/data.internal.service";

function EditWarehouse() {
  const location = useLocation();
  const { warehouseCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["warehouse", { warehouseCode }],
    queryFn: () => getWarehouse({ warehouseCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editWarehouseMutation = useMutation(editWarehouse, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(warehouseValidations),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = form;

  const infoProps = { mode: "EDIT", control, errors, formRender };
  const onSubmit = (data) => {
    editWarehouseMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["warehouse"])
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <WarehouseInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty} url="/setup/warehouse" />
      </form>
    </Layout>
  );
}

export default EditWarehouse;
